import { errorHandler, loadersSlice } from 'Modules'
import { call, put, select, takeLatest } from 'typed-redux-saga'
import {
	sberGeoUnitApi,
	sberGeoUnitSelectors,
	sberGeoUnitNS,
	sberGeoUnitSlice,
} from 'Pages/orders_design'
import { Deserialize } from 'cerialize'
import { Addresses } from 'Pages/orders_design/models/Addresses'

export function* getAddresses(action: sberGeoUnitNS.getAddresses) {
	try {
		const params = yield* select(sberGeoUnitSelectors.getAddressesParams)
		const res = yield* call(sberGeoUnitApi.getAddresses, params)
		const addresses = Deserialize(res, Addresses)
		yield* put(sberGeoUnitSlice.actions.setAddresses(addresses))
	} catch (error) {
		yield* call(errorHandler, error)
	} finally {
		yield* put(loadersSlice.actions.hideGlobalLoader())
	}
}

export function* getAddressesWithParams(action: sberGeoUnitNS.getAddressesWithParams) {
	try {
		yield* put(loadersSlice.actions.showGlobalLoader())
		const { params } = action.payload
		const res = yield* call(sberGeoUnitApi.getAddresses, params)
		yield* put(sberGeoUnitSlice.actions.setAddressesParams(params))
		const addresses = Deserialize(res, Addresses)
		yield* put(sberGeoUnitSlice.actions.setAddresses(addresses))
	} catch (error) {
		yield* call(errorHandler, error)
	} finally {
		yield* put(loadersSlice.actions.hideGlobalLoader())
	}
}

export function* sberGeoUnitSaga() {
	yield* takeLatest(sberGeoUnitSlice.actions.getAddresses, getAddresses)
	yield* takeLatest(sberGeoUnitSlice.actions.getAddressesWithParams, getAddressesWithParams)
}
